export default __webpack_public_path__ + "static/media/relative-book-pro.9a240413.woff2";